import React, { useContext } from 'react';
import BusinessIntelligence from '@components/project/BusinessIntelligence';
import { Spinner } from 'react-bootstrap';
import { usePermissions } from '@components/contexts/PermissionsProvider';
import { WithPermission } from '@lib/helpers/WithPermission';
import { UserContext } from '@components/contexts/UserProvider';

const BusinessIntelligencePage = () => {
	const { isOe } = useContext(UserContext);
	const permissions = usePermissions();
	
	//spinner se non ha permessi ancora caricati e se non è isOe
	if (!isOe && (!permissions || permissions.length === 0)) {
		return <Spinner animation="border" role="status" variant="dark" size="sm" />;
	}

	return (
		<div id="business-intelligence">
			<div className="container-fluid p-0">
				<WithPermission permission="view_bi_dashboard">
					<BusinessIntelligence />
				</WithPermission>
			</div>
		</div>
	);
};

export default BusinessIntelligencePage;
